export class TeardownMongoAtlasPrivateLinkResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TeardownMongoAtlasPrivateLinkResponse.attributeTypeMap;
    }
    constructor() {
    }
}
